import { render, staticRenderFns } from "./DataModal.vue?vue&type=template&id=50cd9840&scoped=true&"
import script from "./DataModal.vue?vue&type=script&lang=js&"
export * from "./DataModal.vue?vue&type=script&lang=js&"
import style0 from "./DataModal.vue?vue&type=style&index=0&id=50cd9840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd9840",
  null
  
)

export default component.exports